/*hambuerger menu*/
const hamburger = document.querySelector('.hamburger_menu');
const slideMenu = document.querySelector('.slide_menu');
const main = document.querySelector('main');
const footer = document.querySelector('footer');

hamburger.addEventListener('click', function () {
  const isActive = this.classList.toggle('active');
  slideMenu.classList.toggle('active');
  document.body.classList.toggle('no-scroll');

  if (isActive) {
    setTimeout(() => {
      if (document.body.classList.contains('no-scroll')) {
        main.style.display = 'none';
        footer.style.display = 'none';
      }
    }, 300);
  } else {
    main.style.display = '';
    footer.style.display = '';
  }
});


/*med_ex_time*/
document.querySelector('.med_ex_time').addEventListener('click', function () {
  if (window.innerWidth <= 767) {
    // 767px以下のときは index.html へリダイレクト
    window.location.href = 'visiter.html#med_ex_time';
  } else {
    // 768px以上ならクラスの切り替えを行う
    this.classList.toggle('active');
    document.querySelector('.med_ex_main').classList.toggle('active');
  }
});

/*下層sidebar*/
const currentURL = window.location.href;

if (currentURL.includes('newslist') || currentURL.includes('news')) {
  document.querySelector('.side_bar_link:nth-child(1)')?.classList.add('active');
}

if (currentURL.includes('visiter')) {
  document.querySelector('.side_bar_link:nth-child(2)')?.classList.add('active');
}

if (currentURL.includes('hospital')) {
  document.querySelector('.side_bar_link:nth-child(3)')?.classList.add('active');
}

if (currentURL.includes('departments')) {
  document.querySelector('.side_bar_link:nth-child(4)')?.classList.add('active');
}

if (currentURL.includes('recruit')) {
  document.querySelector('.side_bar_link:nth-child(5)')?.classList.add('active');
}

if (currentURL.includes('inquiry') || currentURL.includes('privacy')) {
  document.querySelector('.side_bar_link:nth-child(6)')?.classList.add('active');
}


/*smooth scroll*/
const smoothScroll = () => {
  const elms = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

  for (const elm of elms) {
    const href = elm.getAttribute('href');

    if (href === '#') {
      // #のみ
      elm.addEventListener('click', (event) => {
        event.preventDefault();
        scroll({ top: 0, behavior: 'smooth' });
      });
    } else {
      // id指定
      const target = document.querySelector(href);

      if (target) {
        elm.addEventListener('click', (event) => {
          event.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
          });
        });

      }
    }
  }
};

smoothScroll(); 

